/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { SESSION_STORAGE_MEMBERSHIP_CALLBACK } from "../constants/constants";

/**
 * Stores the service (and location) the user wanted to book when they bought
 * a membership to unlock it. Checkout reads this when building the payment
 * return URL, so after payment the widget re-opens with that service picked.
 *
 * Lives in sessionStorage: one writer (useMembershipCheckout), one reader
 * (Checkout.jsx), no re-renders needed, and it must survive the payment
 * round trip anyway.
 *
 * membershipCallbackMiddleware wipes it on any cart change.
 */

export const setMembershipCallback = (params) => {
  if (!params || Object.keys(params).length === 0) {
    sessionStorage.removeItem(SESSION_STORAGE_MEMBERSHIP_CALLBACK);
    return;
  }
  sessionStorage.setItem(SESSION_STORAGE_MEMBERSHIP_CALLBACK, JSON.stringify(params));
};

export const getMembershipCallback = () => {
  try {
    const stored = sessionStorage.getItem(SESSION_STORAGE_MEMBERSHIP_CALLBACK);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const clearMembershipCallback = () => {
  sessionStorage.removeItem(SESSION_STORAGE_MEMBERSHIP_CALLBACK);
};
